<template>
<div>
  <div class="popBg" @click="close"></div>

  <div class="popup fixed">
    <div class="popup__inner fixed z-40 py-5 px-8 bg-white max-w-lg">
      <div class="popup__header text-NotoSansRegular flex justify-between">
        <span>新增地址</span>
        <a @click="close" class=" cursor-pointer">
          <font-awesome-icon icon="times" />
        關閉</a>
      </div>
      <div class="popup__body text-NotoSansRegular textColorDarkBlack flex">
        <form class="w-full">
          <div class="md:flex md:items-center mb-4">
            <div class="md:w-1/5">
              <label class="block textColorDarkBlack font-bold md:text-right mb-1 md:mb-0 pr-4" for="name">
                姓名
              </label>
            </div>
            <div class="md:w-4/5">
              <input class="appearance-none border border-gray-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                id="name" type="text" v-model="name">
            </div>
          </div>
          <div class="md:flex md:items-center mb-4">
            <div class="md:w-1/5">
              <label class="block textColorDarkBlack font-bold md:text-right mb-1 md:mb-0 pr-4" for="mobile">
                手機
              </label>
            </div>
            <div class="md:w-4/5">
              <input v-model="mobile" placeholder="ex:0912345678" class="appearance-none border border-gray-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="mobile" type="text">
            </div>
          </div>
          <div class="md:flex md:items-center mb-4">
            <div class="md:w-1/5">
              <label class="block textColorDarkBlack font-bold md:text-right mb-1 md:mb-0 pr-4" for="tel">
                住家
              </label>
            </div>
            <div class="md:w-4/5">
              <input v-model="tel" placeholder="ex:02-25121234" class="appearance-none border border-gray-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="tel" type="text">
            </div>
          </div>
          <div class="md:flex md:items-center mb-4">
            <div class="md:w-1/5">
              <label class="block textColorDarkBlack font-bold md:text-right mb-1 md:mb-0 pr-4" for="area">
                地址
              </label>
            </div>
            <div class="md:w-4/5">
              <Address v-on:getAddress="getAddress" />
            </div>
          </div>
          <div class="md:flex md:items-center">
            <div class="md:w-1/5">
              <label class="block textColorDarkBlack font-bold md:text-right mb-1 md:mb-0 pr-4 opacity-0" for="address">
                地址
              </label>
            </div>
            <div class="md:w-4/5">
              <input v-model="address" class="appearance-none border border-gray-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="address" type="text" placeholder="">
            </div>
          </div>
        </form>
      </div>
      <div class="popup__buttons flex justify-center">
        <a @click="close" class="button-gray border py-2 px-4 rounded mx-1 focus:outline-none cursor-pointer">
          取消
        </a>
        <a @click="addData" class="button-gray border py-2 px-4 rounded mx-1 focus:outline-none cursor-pointer">
          儲存
        </a>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import Address from '@/components/modules/AddressSection'
import Regex from '@/components/modules/regex'
export default {
  name: 'AddAddressPop',

  data () {
    return {
      name: null,
      mobile: null,
      tel: null,
      city: null,
      district: null,
      zip_code: null,
      address: null
    }
  },
  components: {
    Address
  },
  mixins: [
    Regex
  ],
  methods: {
    close () {
      let self = this
      self.$emit('close', false)
    },
    getAddress (getAddress) {
      let self = this
      self.city = getAddress.city
      self.district = getAddress.district
      self.zip_code = getAddress.zip_code
    },
    addData () {
      let self = this
      if (self.name && self.mobile && self.address && self.tel && self.rexMobile(self.mobile) && self.city && self.district) {
        let obj = {
          name: self.name,
          mobile: self.mobile,
          tel: self.tel,
          city: self.city,
          district: self.district,
          zip_code: self.zip_code,
          address: self.address
        }
        self.$emit('addData', obj)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.popBg {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed !important;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.popup {
  z-index: 1000;
  .popup__inner {
    top: 35%;
    left: 0;
    right: 0;
    margin: 0 auto;
    line-height: 1.5;
    letter-spacing: .05em;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 4px;

    -webkit-transform: scale(0.3);
    -moz-transform: scale(0.3);
    -ms-transform: scale(0.3);
    -o-transform: scale(0.3);
    transform: scale(0.3);

    -webkit-animation-name: example;
    -webkit-animation-duration: .3s;
    animation-name: example;
    animation-duration: .3s;
    animation-fill-mode: forwards;
    .popup__header {
      margin-bottom: 15px;
      font-size: 0.85em;
      font-weight: bold;
      color: #1976D2;
      span {
        border-bottom: 1px solid #1976D2;
      }
    }
    .popup__body {
      margin: 15px 0;
      font-size: 0.85em;
    }
  }
}
@-webkit-keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(1);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}

/* Standard syntax */
@keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(1);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}
</style>
